import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';
import { Address, AddressSchema } from '@40seas/models';
import { AddressMatchLocation, AddressMatchLocationSchema } from './address.match.location.entity';

export const AddressMatchSearchResultSchema = z
    .object({
        location: AddressMatchLocationSchema,
        placeId: z.string().nullish(),
        formattedAddress: z.string(),
        rawData: z.any(),
    })
    .strict();

export class AddressMatchSearchResult extends FromSchema(AddressMatchSearchResultSchema) {
    formattedAddress: string;
    location: AddressMatchLocation;
    placeId: string;
    rawData: any;
}
